export default {
  title: '營銷數據',
  activityInfo: '活動信息',
  activityInfoPlaceholder: '請輸入活動名稱、ID',
  dateRange: '日期範圍',
  statTime: '統計時間',
  startDate: '開始日期',
  endDate: '結束日期',
  // KPI 卡片
  totalScanCount: '掃碼總個數',
  cumulativeScanCount: '累計掃碼個數',
  scanUserCount: '掃碼人數',
  activityUserCount: '參與活動人數',
  winUserCount: '中獎人數',
  yesterday: '昨日:',
  // 趨勢圖
  trendTitle: '掃碼趨勢',
  periodWeek: '本週',
  periodMonth: '本月',
  scanCount: '掃碼個數',
  scanCountSeries: '掃碼個數',
  scanUserCountSeries: '掃碼人數',
  winCount: '中獎人數',
  // 排行榜
  rankTitle: '掃碼產品排行榜（TOP10）',
  rankNo: '排名',
  productName: '產品',
  scanCountCol: '掃碼個數',
};
